module.exports = __webpack_public_path__ + "img/connections.47b857eb.svg";